// ======================================================================
// File: src/modules/ppe/transport/components/transport/TransportKpiBar.jsx
// Module: PPE → Transport
// Purpose:
//   KPI summary strip for Transport operations
//   Pattern aligned with FMS KPI bar
// ======================================================================

import React from "react";
import { useNavigate } from "react-router-dom";


// ======================================================================
// COMPONENT
// ======================================================================

export default function TransportKpiBar({ summary = {} }) {

  const navigate = useNavigate();

  const kpis = [
    {
      label: "Active",
      value: summary.active || 0,
      filter: "ACTIVE",
      className: "bg-primary",
    },
    {
      label: "In Transit",
      value: summary.in_transit || 0,
      filter: "IN_TRANSIT",
      className: "bg-info",
    },
    {
      label: "Delivered",
      value: summary.delivered || 0,
      filter: "DELIVERED",
      className: "bg-success",
    },
    {
      label: "Payment Pending",
      value: summary.payment_pending || 0,
      filter: "PAYMENT_PENDING",
      className: "bg-warning text-dark",
    },
  ];

  const navigateWithFilter = (filter) => {
    navigate(`/ppe/transport/list?status=${filter}`);
  };

  return (
    <div className="row mb-3">

      {kpis.map((kpi, index) => (
        <div key={index} className="col-md-3">
          <div
            className={`card glass-card text-center ${kpi.className}`}
            style={{ cursor: "pointer" }}
            onClick={() => navigateWithFilter(kpi.filter)}
          >
            <div className="card-body">

              <h3 className="mb-1">{kpi.value}</h3>

              <small>{kpi.label}</small>

            </div>
          </div>
        </div>
      ))}

    </div>
  );
}
